import { AfterViewInit, Component, computed, ElementRef, inject, Injector, signal, viewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonButtonRowWidget, CommonDateTimeField, CommonDateTimeFieldConfig, CommonDateTimeFieldWidget, CommonForm } from "@eforall/common";
import { VolunteerDialogDataService } from "../../volunteer-dialog-data.service";

interface FormValues {
	interviewDateUTC: number | undefined;
}


@Component({
	selector: 'lead-volunteer-date-time-form',
	standalone: true,
	imports: [
		CommonDateTimeFieldWidget,
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './lead-volunteer-date-time-form.part.html'
})

export class LeadVolunteerDateTimeFormPart implements AfterViewInit {

	public dateTimeFormSubmitButton = viewChild.required<ElementRef<HTMLButtonElement>>('dateTimeForm');

	private readonly injector = inject(Injector)
	public readonly dialogDataService = inject(VolunteerDialogDataService);
	private readonly form = new CommonForm<FormValues>(this.injector);

	readonly interviewDateTime = computed<CommonDateTimeField>(() => ({
		config: signal<CommonDateTimeFieldConfig>({
			label: 'Interview Date and Time',
			isRequired: true,
			isSpanish: false,
			type: 'event',
			includeTime: true,
			isEnabled: this.dialogDataService.canRecruitVolunteers,
		}),
		formFieldName: 'interviewDateUTC',
		form: this.form,
		actualValue: computed(() => this.dialogDataService.volunteerDetails()?.interviewDateUTC),
		pendingValue: signal<number | undefined | null>(null),
		saving: signal(false),
		error: signal(''),
	}));

	ngAfterViewInit() {
		this.form.setSubmitButton(
			this.dateTimeFormSubmitButton(),
			async (values: FormValues) => {
				if (!this.dialogDataService.canRecruitVolunteers()) return;
				await this.onSaveInterviewDateTime(values);
			}
		)
	}

	async onSaveInterviewDateTime(values: FormValues): Promise<void> {
		const volunteerId = this.dialogDataService.volunteerDetails()?.volunteerId;
		if (volunteerId) {
			await this.dialogDataService.updateVolunteerInterviewDateTime({ interviewDateUTC: values.interviewDateUTC, volunteerId });
		}
	}
}
